import { render, staticRenderFns } from "./TextPaster.vue?vue&type=template&id=316efd8b&scoped=true"
import script from "./TextPaster.vue?vue&type=script&lang=js"
export * from "./TextPaster.vue?vue&type=script&lang=js"
import style0 from "./TextPaster.vue?vue&type=style&index=0&id=316efd8b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316efd8b",
  null
  
)

export default component.exports